import { render } from "./OutsourcedWorkSelector.vue?vue&type=template&id=7a947321&ts=true"
import script from "./OutsourcedWorkSelector.vue?vue&type=script&lang=ts"
export * from "./OutsourcedWorkSelector.vue?vue&type=script&lang=ts"

const cssModules = {}
import style0 from "./OutsourcedWorkSelector.vue?vue&type=style&index=0&id=7a947321&lang=scss&module=true"
cssModules["$style"] = style0

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__